/* eslint-disable */
export default {
  today: '오늘',
  yesterday: '내일',
  empty: '통화 기록 없음',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
